import { UpdateSystemRequestSchema, UpdateSystemResponseSchema } from './update-system.schema';
/**
 * Update System Endpoint Contract
 * Updates an existing system by ID
 */ export const updateSystemContract = {
    method: 'PATCH',
    path: '/api/v2/system/:id',
    description: 'Update an existing system by ID',
    requestSchema: UpdateSystemRequestSchema,
    responseSchema: UpdateSystemResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Bad Request - invalid input data',
            401: 'Unauthorized - user not authenticated',
            404: 'System not found'
        }
    }
};

//# sourceMappingURL=update-system.contract.js.map